import request from 'api'
import {
  convertCountryCode2to3,
  convertLanguageCode2to3,
  countryCode,
  getDefaultLocaleForCountry,
  languageCode
} from 'utils/i18n'

export const getConsentApi = (type: string, includeChild: boolean = false, apiURL?: string, family?: boolean, appId?: string) => {
  const saAppKey = process.env.REACT_APP_CONSENT_APP_KEY
  const appKey = appId || process.env.REACT_APP_CONSENT_APP_KEY
  const now = (new Date().getTime() / 1000).toFixed(0)

  return request.get(apiURL || '/v1/consent', {
    headers: {
      'x-app-id': saAppKey,
      'x-os-version': 'WEB',
      'x-package-name': `${process.env.REACT_APP_NAME}`,
      'x-package-version': `${process.env.REACT_APP_VERSION}`,
      'x-device-id': 'myAccount3',
      'x-model-name': navigator.userAgent,
      'x-requested': now,
      'x-started': now
    },
    params: {
      applicationRegion: 'KOR',
      region: 'KOR',
      language: 'kor',
      appKey,
      type,
      includeChild,
      family
    }
  })
}

export const getConsentApiCountry = (
  type: string,
  includeChild: boolean = false,
  region: string = 'KOR',
  language: string = 'kor',
  apiURL?: string,
  family?: boolean,
  appId?: string
) => {
  const saAppKey = process.env.REACT_APP_CONSENT_APP_KEY
  const appKey = appId || process.env.REACT_APP_CONSENT_APP_KEY
  const now = (new Date().getTime() / 1000).toFixed(0)

  return request.get(apiURL || '/v1/consent', {
    headers: {
      'x-app-id': saAppKey,
      'x-os-version': 'WEB',
      'x-package-name': `${process.env.REACT_APP_NAME}`,
      'x-package-version': `${process.env.REACT_APP_VERSION}`,
      'x-device-id': 'myAccount3',
      'x-model-name': navigator.userAgent,
      'x-requested': now,
      'x-started': now
    },
    params: {
      applicationRegion: region,
      region,
      language,
      appKey,
      type,
      includeChild,
      family
    }
  })
}

type GlobalConsentOptions = {
  apiURL?: string
  family?: boolean
  appId?: string
  overrides?: {
    countryCode?: string
    locale?: string
  }
}

export const getGlobalConsentApi = (type: string, includeChild: boolean = false, options: GlobalConsentOptions = {}) => {
  const { apiURL, family, appId, overrides } = options
  const saAppKey = process.env.REACT_APP_CONSENT_APP_KEY
  const appKey = appId || process.env.REACT_APP_CONSENT_APP_KEY
  const now = (new Date().getTime() / 1000).toFixed(0)

  let targetCountryCode: string
  let targetLanguageCode: string
  const normalizedLocale = overrides?.locale?.replace('_', '-')
  const localeCountryCode = normalizedLocale?.split('-')[1]
  const overrideCountryCode = overrides?.countryCode || localeCountryCode

  if (overrideCountryCode || normalizedLocale) {
    targetCountryCode = overrideCountryCode ? convertCountryCode2to3(overrideCountryCode) : countryCode

    if (normalizedLocale) {
      targetLanguageCode = convertLanguageCode2to3(normalizedLocale.split('-')[0]) || languageCode
    } else {
      const defaultLocale = getDefaultLocaleForCountry(targetCountryCode)
      targetLanguageCode = convertLanguageCode2to3(defaultLocale?.split('-')[0] || 'en') || languageCode
    }
  } else {
    targetCountryCode = countryCode
    targetLanguageCode = languageCode
  }

  return request.get(apiURL || '/v1/consent', {
    headers: {
      'x-app-id': saAppKey,
      'x-os-version': 'WEB',
      'x-package-name': `${process.env.REACT_APP_NAME}`,
      'x-package-version': `${process.env.REACT_APP_VERSION}`,
      'x-device-id': 'myAccount3',
      'x-model-name': navigator.userAgent,
      'x-requested': now,
      'x-started': now
    },
    params: {
      applicationRegion: targetCountryCode,
      region: targetCountryCode,
      language: targetLanguageCode,
      appKey,
      type,
      includeChild,
      family
    }
  })
}
